import { styled } from '@mui/material/styles';
import { Chip } from 'shared/mui/Chips';
import { Datagrid } from 'shared/react-admin/Datagrids';

export const StyledChip = styled(Chip)({
  marginRight: '12px',
});

export const StyledDatagrid = styled(Datagrid)({
  padding: 0,
  borderRadius: '4px',
  '& .MuiTableCell-root': {
    height: '48px',
  },
  '& .MuiTableCell-head': {
    verticalAlign: 'middle',
    paddingTop: '12px',
  },
  '& .column-methodName': {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  '& .column-active': {
    width: 0,
    textAlign: 'center',
  },
  '& .column-pilotMode': {
    width: 0,
    textAlign: 'center',
  },
  '& .column-autoDeactivation': {
    width: 0,
    textAlign: 'center',
  },
});
